module.exports = __webpack_public_path__ + "img/thank7.a946a3d3.gif";